import { Component, ViewChild } from '@angular/core';
import 'moment/locale/id';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { AddModalComponent } from '../add-modal/add-modal.component';
import { CreditNoteRestService } from '../credit-note-rest.service';
import { DetailModalComponent } from '../detail-modal/detail-modal.component';

@Component({
  selector: 'credit-note-list',
  templateUrl: 'credit-note-list.component.html'
})
export class CreditNoteListComponent extends BaseListBComponent<any> {
  @ViewChild(AddModalComponent) addModalComponent: AddModalComponent;
  @ViewChild(DetailModalComponent) detailModal: DetailModalComponent;

  tableColumns = [
    {
      i18nLabel: 'ui.creditNote.entity.dealerName',
      field: 'mainDealerName',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.entity.region',
      field: 'region',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.entity.total',
      field: 'totalCreditNote',
      sort: true
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);

  constructor(private api: CreditNoteRestService) {
    super();
    this.componentId = 'CreditNoteListComponent';
    this.headerTitle = 'ui.creditNote.title';
    this.deleteRecordI18nLabel = 'confirm.any.delete.label';
    this.deleteRecordI18nDescription = 'confirm.any.delete.description';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        return this.api.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map((d: any) => ({
              ...d,
              totalCreditNote: this.formatRupiah(d?.totalCreditNote)
            }));
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () => this.page.compHookService?.callMultipleHooks(['CreditNoteListComponent:workflowLoadData'])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }

  openDetailModal(mainDealerId: string) {
    if (!this.detailModal || !mainDealerId) return;
    this.detailModal.openModal(mainDealerId);
  }

  openCreateModal(mainDealerId: string) {
    if (!this.addModalComponent || !mainDealerId) return;
    this.addModalComponent.openModal(mainDealerId);
  }
}
